import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

const selectLocalizationStringsState = createSelector(
  getCompany,
  ({ localizationStrings }) => localizationStrings,
);

export const selectLocalizationStringsList = createSelector(
  selectLocalizationStringsState,
  ({ list }) => list,
);

export const selectLocalizationLanguages = createSelector(
  selectLocalizationStringsState,
  ({ languages }) => languages,
);

export const selectLocalizationStringsLanguageCode = createSelector(
  selectLocalizationStringsState,
  ({ languageCode }) => languageCode,
);

export const selectDefaultLocalizationLanguageCode = createSelector(
  selectLocalizationLanguages,
  languages => {
    const defaultLanguage = languages.find(language => language.isDefault);

    return defaultLanguage?.code || languages[0]?.code || null;
  },
);

export const selectEnabledStepKeys = createSelector(
  selectLocalizationStringsState,
  ({ enabledStepKeys }) => enabledStepKeys,
);

export const selectAllStepKeys = createSelector(
  selectLocalizationStringsState,
  ({ allStepKeys }) => allStepKeys,
);

export const selectInputConceptsByStep = createSelector(
  selectLocalizationStringsState,
  ({ inputConceptsByStep }) => inputConceptsByStep,
);
